import React from "react";
import { Icon, MenuItem as ChakraMenuItem } from "@chakra-ui/react";
export function MenuItem({ icon, variant, ...props }) {
    return (React.createElement(ChakraMenuItem, { icon: icon ? React.createElement(Icon, { as: icon, boxSize: 6 }) : undefined, color: variant === "danger" ? "text.danger" : undefined, ...props }));
}
